import { useEffect, useMemo, useState } from 'react';
import useSWR from 'swr';
import { isEqual } from 'lodash';
import { TextEditor } from '@shared/components/TextEditor';
import { SaveButton } from '@shared/components/SaveButton';
import { RelativeWrapper } from '@shared/styledComponents';
import { FormWithPrompt } from '@shared/components/FormWithPrompt';
import { ILenderEditorTabProps } from '../LenderEditorTabs';
import { requestUpdateRequirements } from './queries';

export const Requirements = ({ lenderId }: ILenderEditorTabProps) => {
  const { data: lenderUtility } = useSWR(() => `/lender-service/lenders/${lenderId}`);
  const [updating, setUpdating] = useState(false);
  const [requirements, setRequirements] = useState('');
  
  const lenderUtilityValue = useMemo(() => lenderUtility?.generalInfo?.requirements || '', [lenderUtility?.generalInfo?.requirements]);
  const dirty = useMemo(() => !isEqual(lenderUtilityValue, requirements), [lenderUtilityValue, requirements]);
  const saveButtonDisabled = useMemo(() => updating || !dirty, [updating, dirty]);

  useEffect(() => {
    if (lenderUtilityValue) {
      setRequirements(lenderUtilityValue);
    }
  }, [lenderUtilityValue]);

  const onSave = async () => {
    setUpdating(true);
    await requestUpdateRequirements(lenderId, lenderUtility.numericId, requirements);
    setUpdating(false);
  };

  return (
      <RelativeWrapper>
        <FormWithPrompt
          dirtyWithoutFormik
          isDirty={dirty}
        />
          <SaveButton
            disabled={saveButtonDisabled}
            isLoading={updating}
            displayMessage="Unsaved Changes"
            onClick={onSave}
          />
          <TextEditor
            key={lenderUtility?.id}
            text={lenderUtilityValue}
            onChange={(value) => setRequirements(value)}
          />
      </RelativeWrapper>
  );
};
